import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GaugeChartComponent } from './gauge-chart.component';

const routes: Routes = [
  {
    path: '',
    component: GaugeChartComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GaugeChartRoutingModule {}
